import React, { useEffect, useState } from "react";
import axios from "axios";
import { FormControlLabel, Checkbox, Box, Alert } from "@mui/material";
import localize from "../../../common/localize";
import { getFieldTypeName } from "../../../common/utils";
import Combobox from "../../../components/common/Combobox";
import useGlobalContext from "../../../hooks/useGlobalContext";
import { getclearFormFieldModel } from "../../../common/EntitiesManagement";
import PageTitleSubtitle from "../../../components/PageTitleSubTitle";
import CreatedByText from "../../../components/common/CreatedByText";

export default function AddOrEditFormField({ model, setModel }) {
  const { FORM_FIELDS_ENDPOINT, config } = useGlobalContext();
  const [formFieldData, setFormFieldData] = useState(undefined);

  const getFormFieldsData = async () => {
    const requestConfig = {
      ...config,
    };
    requestConfig.headers.pagination = -1;
    const data = await axios.get(`${FORM_FIELDS_ENDPOINT}/`, requestConfig);
    setFormFieldData(data?.data);
  };

  useEffect(() => {
    getFormFieldsData();
  }, []);

  const handleCheckedChanged = (e) => {
    setModel({
      ...model,
      [e.target.name]: e.target.checked,
    });
  };

  const handleFormFieldChange = (value) => {
    if (value) {
      setModel({
        ...model,
        FormField: value,
        FieldId: value.Id,
        ValueTypeData: {
          Id: value.ValueType,
          Name: getFieldTypeName(value.ValueType),
        },
        Title: value.Title,
        Description: value.Description,
        AvailableOnReview: value.AvailableOnReview,
        Multiline: value.Multiline,
        Mandatory: value.Mandatory,
        VisibleOnMobile: value.VisibleOnMobile,
      });
      return;
    }
    if (!value) {
      setModel(getclearFormFieldModel());
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <form className="w-full">
        <div className="flex flex-wrap my-2">
          <Combobox
            isRequired
            id="FormField"
            handleValueChange={handleFormFieldChange}
            fieldValue={model?.FormField}
            fieldOptions={formFieldData?.Data ?? []}
            fieldLabel={localize.select_field}
            customOptionLabel={(option) => option.Title}
          />
        </div>

        {model?.FormField && (
          <Box className="flex flex-col gap-2">
            <Box className="flex justify-between">
              <Box className="two_columns_grid">
                <label className="text-xs">
                  <b>{localize.field_type}: </b>
                </label>
                <label className="text-xs">
                  {getFieldTypeName(model?.ValueTypeData.Id)}
                </label>

                <label className="text-xs">
                  <b>{localize.title}: </b>
                </label>
                <label className="text-xs">{model.Title}</label>
              </Box>
            </Box>

            {model.Description && model.Description.length > 0 && (
              <Alert className="w-full" severity="info">
                <label className="text-xs">
                  <b>{localize.help_text}: </b>
                  {model.Description}
                </label>
              </Alert>
            )}

            <div className="flex my-2 flex-col gap-2">
              <FormControlLabel
                size="small"
                name="VisibleOnMobile"
                control={
                  <Checkbox
                    size="small"
                    name="VisibleOnMobile"
                    checked={model.VisibleOnMobile}
                    onChange={handleCheckedChanged}
                  />
                }
                label={
                  <span style={{ fontSize: "0.8em" }}>
                    <PageTitleSubtitle
                      useFieldTitleStyle
                      useEventTitleStyle
                      title={localize.visible_on_mobile}
                      subtitle={localize.visible_on_mobile_info}
                    />
                  </span>
                }
              />

              <FormControlLabel
                size="small"
                name="Mandatory"
                control={
                  <Checkbox
                    size="small"
                    name="Mandatory"
                    checked={model.Mandatory}
                    onChange={handleCheckedChanged}
                  />
                }
                label={
                  <span style={{ fontSize: "0.8em" }}>
                    <PageTitleSubtitle
                      useFieldTitleStyle
                      useEventTitleStyle
                      title={localize.mandatory}
                      subtitle={localize.mandatory_info}
                    />
                  </span>
                }
              />

              {model?.FormField?.Id > 0 &&
                (model?.FormField?.ValueType === "STRING" ||
                  model?.FormField?.ValueType === "SIGNATURE") && (
                  <FormControlLabel
                    size="small"
                    name="Multiline"
                    control={
                      <Checkbox
                        size="small"
                        name="Multiline"
                        checked={model?.Multiline}
                        onChange={handleCheckedChanged}
                      />
                    }
                    label={
                      <span style={{ fontSize: "0.8em" }}>
                        {model?.FormField?.ValueType === "SIGNATURE"
                          ? localize.form_signature
                          : localize.multiline_text}
                      </span>
                    }
                  />
                )}
            </div>
          </Box>
        )}
      </form>

      <CreatedByText entity={model} />
    </div>
  );
}
